<template>
    <v-dialog v-model="deleteAlarmDialog" persistent max-width="290">
        <template v-slot:activator="{ on }">
            <v-btn
                    text
                    icon
                    color="red"
                    v-on="on"
            >
                <v-icon>mdi-delete-circle</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="headline">Delete Alarm</v-card-title>
            <v-card-text>
                Are you sure you want to delete: {{this.alarm.stockExchange}}?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="this.deleteAlarm">Delete</v-btn>
                <v-btn color="green darken-1" text @click="deleteAlarmDialog = false">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {DELETE_ALARM} from "@/store/actions.type";

    export default {
        name: "DeleteAlarmButton",
        props: {
            alarm: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                "deleteAlarmDialog": null
            }
        },
        methods: {
            deleteAlarm() {
                this.$store.dispatch(DELETE_ALARM, this.alarm.alarmId);
                this.deleteAlarmDialog = false;
            }
        }
    }
</script>

<style scoped>

</style>